import CatalogObjectAdapter from '@square/dashboard-items-data/adapters/connect/catalog-object';
export default class ItemOption extends CatalogObjectAdapter {}